import { useCallback, useState } from "react";
import { AavoButton, AavoButtonProps } from "./AavoButton";
import { AsyncFunction } from "src/types/functions";
import { AnyError } from "src/errorHandling/anyError";
import { ErrorDialog } from "src/components/common/dialogs/errorDialog/ErrorDialog.tsx";
import { logError } from "src/errorHandling/errorLogging";

export interface AsyncButtonProps extends Omit<AavoButtonProps, "loading" | "onClick"> {
	onClick?: AsyncFunction<void, any>;
}

export const AsyncButton = ({
								onClick,
								children,
								...other
							}: AsyncButtonProps) => {
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<AnyError | undefined>(undefined);
	const handleClick = useCallback(async () => {
		if (onClick === undefined) return;
		setLoading(true);
		try {
			await onClick();
		} catch (e) {
			logError(e as AnyError);
			setError(e as AnyError);
		} finally {
			setLoading(false);
		}
	}, [setLoading, onClick, setError]);

	const onCloseErrorDialog = useCallback(() => {
		setError(undefined);
	}, [setError]);

	return (
		<>
			<AavoButton onClick={handleClick} loading={loading}
						{...other} >
				{children}
			</AavoButton>
			<ErrorDialog error={error} onClose={onCloseErrorDialog} />
		</>
	);
};
